/**
 * @generated SignedSource<<e544ec9df9c2d87e7e30e8677bd2c7de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BusinessPlaceType = "etc" | "lease" | "noHave" | "own";
export type ErrorType = "ERR_ADSLOT" | "ERR_CARD_BIRTH" | "ERR_CARD_EXPIRED" | "ERR_CARD_NUMBER" | "ERR_CARD_PASSWORD" | "ERR_CARD_PASSWORD_FIVE_TIMES" | "ERR_CREATE_SURVEY_ANSWER" | "ERR_DUPLICATE_APPLY" | "ERR_ETC" | "ERR_EXIST_FINISH_REFUND" | "ERR_EXIST_SEARCH_HISTORY" | "ERR_EXPIRE_URL" | "ERR_HECTO_ETC" | "ERR_HOMETAX_BLOCK_ID" | "ERR_HOMETAX_CALCULATE" | "ERR_HOMETAX_COLLECT" | "ERR_HOMETAX_ETC" | "ERR_HOMETAX_EXPIRE_CERT" | "ERR_HOMETAX_IMPOSSIBLE" | "ERR_HOMETAX_INPUT" | "ERR_HOMETAX_NO_BMAN" | "ERR_HOMETAX_NO_CONTINUE_BMAN" | "ERR_HOMETAX_NO_CORPS_ID" | "ERR_HOMETAX_NO_INCOME_TAX" | "ERR_HOMETAX_NO_JUMIN_ID" | "ERR_HOMETAX_NO_REGIST_CERT" | "ERR_HOMETAX_NO_USER" | "ERR_HOMETAX_OVERLOAD" | "ERR_HOMETAX_PASSWORD" | "ERR_HOMETAX_PASSWORD_CHANGE_REQUEST" | "ERR_HOMETAX_REG_NO" | "ERR_HOMETAX_SERVER_FIX" | "ERR_HOMETAX_SESSION" | "ERR_HOMETAX_SIMPLE_AUTH" | "ERR_HOMETAX_TIMEOUT" | "ERR_LEAVE_REASON" | "ERR_LEAVE_REASON_LOG" | "ERR_NON_PRODUCT_PROMOTION" | "ERR_NOT_EXIST_HISTORY" | "ERR_NOT_EXIST_YEAR_END_TAX_SETTLEMENT" | "ERR_NO_EQUAL_TIN" | "ERR_PROMOTION" | "ERR_SSO" | "ERR_SURVEY" | "ERR_SURVEY_ANSWER" | "ERR_SURVEY_COMPLETED" | "ERR_SURVEY_EXPIRED" | "ERR_UPDATE_SURVEY_ANSWER" | "ERR_USER" | "ERR_USER_ACTION_LOG" | "ERR_USER_PHONE";
export type NewSignboardType = "newSignboard" | "noHave" | "takingOver";
export type PartnerAtEstablishmentType = "blank" | "joinMidway" | "no" | "yes";
export type TakingOverEmployeesType = "no" | "unknown" | "yes";
export type YesNoBlank = "blank" | "no" | "yes";
export type YesNoBlankAddressUnknown = "addressUnknown" | "blank" | "no" | "yes";
export type YesNoEtc = "etc" | "no" | "yes";
export type SurveyEmployeeInput = {
  attrYears: ReadonlyArray<string>;
  birthday?: string | null | undefined;
  ieNm: string;
  indvTin: string;
};
export type LocationInput = {
  address: string;
  isFirstLocation: YesNoBlank;
  isUnknownRelocationYear: boolean;
  year?: number | null | undefined;
};
export type businessAnswerUpsertMutation$variables = {
  bmanTin: string;
  businessPlaceType?: BusinessPlaceType | null | undefined;
  businessPlaceTypeComment?: string | null | undefined;
  hasPartnerAtTheTimeOfEstablishment?: PartnerAtEstablishmentType | null | undefined;
  hasPreviousBusinessInSameIndustry?: YesNoBlank | null | undefined;
  hasTakingOverEmployees?: TakingOverEmployeesType | null | undefined;
  isCompleted: boolean;
  isFirstLocation?: YesNoBlankAddressUnknown | null | undefined;
  isNewSignboard?: NewSignboardType | null | undefined;
  isSmallBossOrMachineOwner?: YesNoBlank | null | undefined;
  isStartBusinessDirectly?: YesNoEtc | null | undefined;
  isWorkingAtRegisteredAddress?: YesNoBlank | null | undefined;
  locations?: ReadonlyArray<LocationInput> | null | undefined;
  surveyAnswerId: string;
  takingOverEmployees?: ReadonlyArray<SurveyEmployeeInput> | null | undefined;
};
export type businessAnswerUpsertMutation$data = {
  readonly upsertBusinessAnswer: {
    readonly errors: {
      readonly code: ErrorType;
      readonly message: string | null | undefined;
    } | null | undefined;
    readonly result: boolean;
  };
};
export type businessAnswerUpsertMutation = {
  response: businessAnswerUpsertMutation$data;
  variables: businessAnswerUpsertMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bmanTin"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "businessPlaceType"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "businessPlaceTypeComment"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasPartnerAtTheTimeOfEstablishment"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasPreviousBusinessInSameIndustry"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasTakingOverEmployees"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isCompleted"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isFirstLocation"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isNewSignboard"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSmallBossOrMachineOwner"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isStartBusinessDirectly"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isWorkingAtRegisteredAddress"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "locations"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "surveyAnswerId"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "takingOverEmployees"
},
v15 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "bmanTin",
        "variableName": "bmanTin"
      },
      {
        "kind": "Variable",
        "name": "businessPlaceType",
        "variableName": "businessPlaceType"
      },
      {
        "kind": "Variable",
        "name": "businessPlaceTypeComment",
        "variableName": "businessPlaceTypeComment"
      },
      {
        "kind": "Variable",
        "name": "hasPartnerAtTheTimeOfEstablishment",
        "variableName": "hasPartnerAtTheTimeOfEstablishment"
      },
      {
        "kind": "Variable",
        "name": "hasPreviousBusinessInSameIndustry",
        "variableName": "hasPreviousBusinessInSameIndustry"
      },
      {
        "kind": "Variable",
        "name": "hasTakingOverEmployees",
        "variableName": "hasTakingOverEmployees"
      },
      {
        "kind": "Variable",
        "name": "isCompleted",
        "variableName": "isCompleted"
      },
      {
        "kind": "Variable",
        "name": "isFirstLocation",
        "variableName": "isFirstLocation"
      },
      {
        "kind": "Variable",
        "name": "isNewSignboard",
        "variableName": "isNewSignboard"
      },
      {
        "kind": "Variable",
        "name": "isSmallBossOrMachineOwner",
        "variableName": "isSmallBossOrMachineOwner"
      },
      {
        "kind": "Variable",
        "name": "isStartBusinessDirectly",
        "variableName": "isStartBusinessDirectly"
      },
      {
        "kind": "Variable",
        "name": "isWorkingAtRegisteredAddress",
        "variableName": "isWorkingAtRegisteredAddress"
      },
      {
        "kind": "Variable",
        "name": "locations",
        "variableName": "locations"
      },
      {
        "kind": "Variable",
        "name": "surveyAnswerId",
        "variableName": "surveyAnswerId"
      },
      {
        "kind": "Variable",
        "name": "takingOverEmployees",
        "variableName": "takingOverEmployees"
      }
    ],
    "concreteType": "RefundUserPutSurveyAnswerOutput",
    "kind": "LinkedField",
    "name": "upsertBusinessAnswer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Errors",
        "kind": "LinkedField",
        "name": "errors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "businessAnswerUpsertMutation",
    "selections": (v15/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v13/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v10/*: any*/),
      (v4/*: any*/),
      (v9/*: any*/),
      (v8/*: any*/),
      (v5/*: any*/),
      (v14/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v11/*: any*/),
      (v7/*: any*/),
      (v12/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "businessAnswerUpsertMutation",
    "selections": (v15/*: any*/)
  },
  "params": {
    "cacheID": "acf2a76b029e1c57b078bf8a012012c8",
    "id": null,
    "metadata": {},
    "name": "businessAnswerUpsertMutation",
    "operationKind": "mutation",
    "text": "mutation businessAnswerUpsertMutation(\n  $surveyAnswerId: String!\n  $bmanTin: String!\n  $isCompleted: Boolean!\n  $isStartBusinessDirectly: YesNoEtc\n  $hasPreviousBusinessInSameIndustry: YesNoBlank\n  $isSmallBossOrMachineOwner: YesNoBlank\n  $isNewSignboard: NewSignboardType\n  $hasTakingOverEmployees: TakingOverEmployeesType\n  $takingOverEmployees: [SurveyEmployeeInput!]\n  $businessPlaceType: BusinessPlaceType\n  $businessPlaceTypeComment: String\n  $isWorkingAtRegisteredAddress: YesNoBlank\n  $isFirstLocation: YesNoBlankAddressUnknown\n  $locations: [LocationInput!]\n  $hasPartnerAtTheTimeOfEstablishment: PartnerAtEstablishmentType\n) {\n  upsertBusinessAnswer(surveyAnswerId: $surveyAnswerId, bmanTin: $bmanTin, isCompleted: $isCompleted, isStartBusinessDirectly: $isStartBusinessDirectly, hasPreviousBusinessInSameIndustry: $hasPreviousBusinessInSameIndustry, isSmallBossOrMachineOwner: $isSmallBossOrMachineOwner, isNewSignboard: $isNewSignboard, hasTakingOverEmployees: $hasTakingOverEmployees, takingOverEmployees: $takingOverEmployees, businessPlaceType: $businessPlaceType, businessPlaceTypeComment: $businessPlaceTypeComment, isWorkingAtRegisteredAddress: $isWorkingAtRegisteredAddress, isFirstLocation: $isFirstLocation, locations: $locations, hasPartnerAtTheTimeOfEstablishment: $hasPartnerAtTheTimeOfEstablishment) {\n    result\n    errors {\n      code\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c96296af3accf37d54b38dcfdd9b13f5";

export default node;
